import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { PasswordModule } from 'primeng/password';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TagModule } from 'primeng/tag';
import { InputTextarea } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { CompaniesComponent } from './list/companies-list.component';
import { CompaniesDetailComponent } from './detail/companies-detail.component';
import { CompaniesRoutingModule } from './companies-routing.module';
import { ContractsDetailComponent } from './contracts/contracts-detail.component';
import { ContractZonesDetailComponent } from './contracts/zones-detail/zones-detail.component';
import { ContractProcessorsDetailComponent } from './contracts/processors-detail/processors-detail.component';
import { ContractCapabilitiesDetailComponent } from './contracts/capabilities-detail/capabilities-detail.component';
import { ContractSlasDetailComponent } from './contracts/slas-detail/slas-detail.component';
import { ContractSlaCapabilitiesComponent } from './contracts/slas-detail/sla-capabilities/sla-capabilities.component';
import { ContractSlaNotificationComponent } from './contracts/slas-detail/sla-notification/sla-notification.component';
import { ContractMailAccountsDetailComponent } from './contracts/mails-detail/mails-detail.component';
import { ContractWorkersDetailComponent } from './contracts/workers-detail/workers-detail.component';
import { ContractInboundPhoneDetailComponent } from './contracts/inbound-phone-detail/inbound-phone-detail.component';
import { ContractOutboundPhoneDetailComponent } from './contracts/outbound-phone-detail/outbound-phone-detail.component';
import { ContractTransactionSeriesDetailComponent } from './contracts/transaction-series-detail/transaction-series-detail.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ContractInboundMailDetailComponent } from './contracts/inbound-mail-detail/inbound-mail-detail.component';
import { OutgoingMailDetailComponent } from './contracts/outgoing-mail-detail/outgoing-mail-detail.component';


import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        CompaniesComponent,
        CompaniesDetailComponent,
        ContractsDetailComponent,
        ContractZonesDetailComponent,
        ContractProcessorsDetailComponent,
        ContractWorkersDetailComponent,
        ContractCapabilitiesDetailComponent,
        ContractSlasDetailComponent,
        ContractSlaCapabilitiesComponent,
        ContractSlaNotificationComponent,
        ContractMailAccountsDetailComponent,
        ContractInboundPhoneDetailComponent,
        ContractOutboundPhoneDetailComponent,
        ContractInboundMailDetailComponent,
        // ContractCaseLogDetailComponent,
        ContractTransactionSeriesDetailComponent,
        OutgoingMailDetailComponent
    ], imports: [CoreModule,
        CompaniesRoutingModule,
        BrowserModule,
        FormsModule,
        TableModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        InputSwitchModule,
        PasswordModule,
        DropdownModule,
        ConfirmDialogModule,
        PanelModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        TagModule,
        InputTextarea,
        TooltipModule,
        DropdownModule,
        DialogModule,
        EditorModule,
        ReactiveFormsModule,
        MultiSelectModule,
        KeyFilterModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CompaniesModule { }
